// The order defined here will be the order shown in the UI
export const languages = [
    { code: 'en', locale: 'en-US', name: 'English' },
    { code: 'pt-br', locale: 'pt-BR', name: 'Português - Brasil' },
    { code: 'pt-pt', locale: 'pt-PT', name: 'Português - Portugal' },
    { code: 'es-es', locale: 'es-ES', name: 'Español - España' },
    { code: 'es', locale: 'es-MX', name: 'Español' },
    { code: 'ru', locale: 'ru-RU', name: 'Русский' },
    { code: 'ua', locale: 'uk-UA', name: 'Українська' },
    { code: 'it', locale: 'it-IT', name: 'Italiano' },
    { code: 'de', locale: 'de-DE', name: 'Deutsch' },
    { code: 'fr', locale: 'fr-FR', name: 'Français' },
    { code: 'et', locale: 'et-EE', name: 'Eesti' },
    { code: 'pl', locale: 'pl-PL', name: 'Polski' },
    { code: 'nl', locale: 'nl-NL', name: 'Nederlands' },
    { code: 'fi', locale: 'fi-FI', name: 'Suomi' },
    { code: 'el', locale: 'el-GR', name: 'Ελληνική' },
    { code: 'ja', locale: 'ja-JP', name: '日本語' },
    { code: 'th', locale: 'th-TH', name: 'ภาษาไทย' },
    { code: 'cn', locale: 'zh-TW', name: '中文' },
    { code: 'he', locale: 'he-IL', name: 'עברית' },
    { code: 'ko', locale: 'ko-KR', name: '한국어' },
    { code: 'sv', locale: 'sv-SE', name: 'Svenska' },
    { code: 'no', locale: 'no-NO', name: 'Norsk' },
    { code: 'lt', locale: 'lt-LT', name: 'Lietuvių' },
    { code: 'vn', locale: 'vi-VN', name: 'Tiếng Việt' },
    { code: 'hu', locale: 'hu-HU', name: 'Magyar' },
    { code: 'sk', locale: 'sk-SK', name: 'Slovenčina' },
    { code: 'cs', locale: 'cs-CZ', name: 'Čeština' },
    { code: 'ro', locale: 'ro-RO', name: 'Română' },
    { code: 'tr', locale: 'tr-TR', name: 'Türkçe' },
    // { code: 'ca', locale: 'ca-ES', name: 'Català' },
    // { code: 'ar', locale: 'ar-SA', name: 'العربية' }, // Not allowed by MFD yet
];
